export interface GetYurticiCargoListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetYurticiCargoListPagingAndFilterResponseData
}

export interface GetYurticiCargoListPagingAndFilterResponseData {
    items: GetYurticiCargoListPagingAndFilterResponseItem[]
    totalRecordCount: number
    totals: GetYurticiCargoListPagingAndFilterResponseTotals | undefined
}

/** Görüntülenen sayfadaki kayıtların dip toplamı. */
export interface GetYurticiCargoListPagingAndFilterResponseTotals {
    expectedIncomeTotals: string
    expectedOutcomeTotals: string
    saleInvoiceTotalAmount: number
    purchaseInvoiceTotalAmount: number
    rowCount: number
}

export interface GetYurticiCargoListPagingAndFilterResponseItem {
    yurticiCargoId: string
    companyId: string
    refNo: string
    customerId?: string
    shippingCode: string
    integrationRefNo: string
    divisionId?: string
    poId?: string
    poNo?: string
    isPoManual: boolean
    /** "Gönderici - Alıcı Kayıtlı Değil" tanımıyla sistem eşleştirdi (listede "Otomatik"). */
    isPoAuto?: boolean
    poAutoDateStr?: string
    /** Takip süresi dolduğu hâlde teslim edilmemiş ya da faturası gelmemiş. */
    isIncomplete: boolean
    incompleteReason?: string
    poManualDateStr?: string
    poManualUserName?: string
    customerName?: string
    divisionName?: string
    poName?: string
    senderCustomerCode: string
    senderCustomerId: string
    senderCustomerAddress: string
    senderCountyId: string
    senderDistrictId: string
    receiverCustomerCode: string
    receiverCustomerId: string
    receiverCustomerAddress: string
    receiverCountyId: string
    receiverDistrictId: string
    senderCustomerName: string
    receiverCustomerName: string
    senderCountyName: string
    senderDistrictName: string
    receiverCountyName: string
    receiverDistrictName: string
    exitUnitId: string
    arrivalUnitId: string
    deliveryUnitId: string
    exitUnitName: string
    arrivalUnitName: string
    deliveryUnitName: string
    shippingStatusId: string
    shippingCreateDate: string
    shippingLoadDate: string
    shippingDeliverDate: any
    shippingDeliverer: string
    shippingReceiver: any
    shippingStatusName: string
    yurticiCargoProducts: GetYurticiCargoListPagingAndFilterResponseYurticiCargoProduct[]
    documentNo: string
    documentTypeId: string
    receivingTypeId: string
    deliveringTypeId: string
    shippingRegionId: string
    documentTypeName: string
    receivingTypeName: string
    deliveringTypeName: string
    shippingRegionName: string
    yurticiCargoExpectedIncomeOutcomes: any[]
    fileArchives: any[]
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export interface GetYurticiCargoListPagingAndFilterResponseYurticiCargoProduct {
    yurticiCargoProductId: string
    yurticiCargoId: string
    quantity: number
    potTypeId: string
    product: string
    weight: number
    desi: number
    detailVolumetricWeight: number
    potTypeName: string
}

export const initialGetYurticiCargoListPagingAndFilterResponseData: GetYurticiCargoListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0,
    totals: undefined
}